import { render, staticRenderFns } from "./MainWithSidebar.vue?vue&type=template&id=6626e6f7&scoped=true&"
import script from "./MainWithSidebar.vue?vue&type=script&lang=js&"
export * from "./MainWithSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MainWithSidebar.vue?vue&type=style&index=0&id=6626e6f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626e6f7",
  null
  
)

export default component.exports